<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <app-side-nav class="margin-top" [ngClass]="{'hazard-overlay': showHazardOverlay}" *ngIf="showSideMenu"></app-side-nav>
  <app-ai-assistant-widget *ngIf="showSideMenu && aiFeaturesEnabled"></app-ai-assistant-widget>
  <div *ngIf="showLoader" class="loader">
    <div class="container">
      <ion-spinner color="primary" name="lines"></ion-spinner>
    </div>
  </div>
</ion-app>